import React from 'react'
import { useNavigate } from 'react-router-dom'
import Page from '../../Components/Page/BookingPage'
import { requestLoginCodeByPhone, verifyOTPLoginCode} from "../../services/CustomerPortal";
import useCustomerAuthStore from '../../states/customerAuth';
import styles from './login.module.css'
import { BsShieldLockFill } from "react-icons/bs";

function Login() {
    const navigate = useNavigate();
    const setAuthenticated = useCustomerAuthStore((state) => state.setAuthenticated);
    const [phone, setPhone] = React.useState('');
    const [error, setError] = React.useState(null);
    const [codeSent, setCodeSent] = React.useState(false)
    const [code, setCode] = React.useState('');

    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, []);

    async function handleRequestOTPCode() {
        setError(null);
        try {
            await requestLoginCodeByPhone(phone);
            setCodeSent(true)
        } catch (err) {
            setError(err.message);
        }
    }

    async function handleVerifyOTPCode() {
        setError(null);
        try {
            const response = await verifyOTPLoginCode(phone, code);
            setAuthenticated(response.customer_id);
            navigate('/customer-portal-info', { replace: true });
        } catch (err) {
            setError(err.message);
        }
    }

    return (
        <Page grid={false}>
            <div className={styles.container}>
                <div className={styles.headerContainer}>
                    <div className={styles.iconContainer}>
                        <BsShieldLockFill size={48} className={styles.icon}/>
                    </div>
                    <div className={styles.headerTextContainer}>
                        <h1 className={styles.header}>Customer Login</h1>
                        {!codeSent ? (
                            <p className={styles.subHeader}>Please enter your phone number to receive a login code.</p>
                        ) : (
                            <p className={styles.subHeader}>Please enter the 6 digit code sent to your phone.</p>
                        )}
                    </div>
                </div>

                {!codeSent ? ( 
                    <div className={styles.innerContainer}>
                        <input
                            type="text"
                            placeholder="Enter your phone number"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className={styles.phoneInput}
                        />
                        <button onClick={handleRequestOTPCode} className={styles.button}>Request Code</button>
                        <p className={styles.hintText}>
                            By entering your phone number and clicking "Request Code", you consent to receive one-time passcodes and account alerts via SMS from Nails By Astraea. 
                            <br/> Message and data rates may apply. 
                            <br/> <a href="/policy" target="_blank" className={styles.hintLink}>View our Terms of Service and Privacy Policy.</a>
                        </p>
                    </div>
                ):(
                    <div className={styles.innerContainer}>
                        <input
                            type="text"
                            placeholder="Enter the 6 digit code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            className={styles.pinInput}
                            maxlength={6}
                            autocomplete="one-time-code"
                        />
                        <button onClick={handleVerifyOTPCode} className={styles.button}>Submit Code</button>
                    </div>
                )}
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </div>

        </Page>
    )
}

export default Login
